import React, { useCallback, forwardRef } from 'react'
import { useDispatch } from 'react-redux'

import PropTypes from 'prop-types'

import isEmpty from 'lodash/isEmpty'
import toLower from 'lodash/toLower'

import pesticideManufacturerSchema from '@galo-monitor/forms/schemas/root/pesticideManufacturer.schema'
import { useT } from '@galo-monitor/i18n'
import { useSnackbar } from '@galo-monitor/snackbar'
import { PesticideActions } from '@galo-monitor/stores/pesticide'
import Form from '@galo-monitor/web-components/Form'
import InputText from '@galo-monitor/web-components/InputText'

import { Container } from './theme'

const PesticideManufacturerForm = forwardRef((props, formRef) => {
  const { manufacturer, loading, setLoading, onSuccess, onError } = props
  const dispatch = useCallback(useDispatch(), [])
  const t = useT()
  const snackbar = useSnackbar()

  const handleSubmit = useCallback(
    (data) => {
      setLoading(true)

      dispatch(PesticideActions.savePesticideManufacturer(
        {
          ...manufacturer,
          ...data
        },
        () => {
          snackbar.success(t('{this} {action} successfully!', {
            this: t('manufacturer', { howMany: 1 }),
            action: toLower(t(isEmpty(manufacturer) ? 'created' : 'updated', { gender: 'male', howMany: 1 }))
          }))
          onSuccess()
        },
        onError
      ))
    },
    [dispatch, onError, onSuccess, manufacturer, setLoading, snackbar, t]
  )

  return (
    <Form
      ref={ formRef }
      schemaConstructor={ pesticideManufacturerSchema }
      onSubmit={ handleSubmit }
    >
      <Container>
        <InputText
          name="name"
          label={ t('name') }
          defaultValue={ manufacturer?.name ?? '' }
          disabled={ loading }
          fullWidth
        />
      </Container>
    </Form>
  )
})

PesticideManufacturerForm.propTypes = {
  manufacturer: PropTypes.object,
  loading: PropTypes.bool,
  setLoading: PropTypes.func,
  onSuccess: PropTypes.func,
  onError: PropTypes.func
}

PesticideManufacturerForm.defaultProps = {
  manufacturer: {},
  loading: false,
  setLoading: () => {},
  onSuccess: () => {},
  onError: () => {}
}

export default PesticideManufacturerForm
